// Machine-drafted — review with a native speaker before launch.
const schedule = {
	schedule: {
		// Shared
		cancel: 'Cancelar',
		next: 'Siguiente',
		continue: 'Continuar',
		loading: 'Cargando ...',
		edit: 'Editar',
		yes: 'Sí',
		no: 'No',
		add: 'Añadir',
		update: 'Actualizar',
		errorTitle: 'Error',
		oops: '¡Vaya!',
		searchRecipients: 'Buscar destinatarios',

		// Header
		editCard: 'Editar tarjeta',

		// Progress bar / steps
		progress: 'Progreso',
		step1: 'Paso 1',
		step2: 'Paso 2',
		step3: 'Paso 3',
		letsSendYourCard: 'Enviemos tu tarjeta',
		stepAddRecipients: 'Añade algunos destinatarios',
		stepConnectEmail: 'Conecta tu cuenta de correo',
		stepCustomizeSubject: 'Personaliza el asunto',

		// Sender detail / email account
		selectEmailAccount: 'Selecciona una cuenta de correo',
		selectPreferredEmail: 'Selecciona tu cuenta de correo preferida para enviar tarjetas.',
		noEmailAccounts: 'No hay cuentas de correo para mostrar',
		addNewEmailAccount: '+ Añadir nueva cuenta de correo',
		confirmEmailAccount: 'Confirmar cuenta de correo',
		sendUsingDefaultTitle: 'Enviar usando nuestro sistema de correo predeterminado',
		sendViaDefault: 'Enviar mediante la dirección de correo predeterminada',
		connectPersonalEmail: 'Conecta tu dirección de correo personal',
		orSendDefaultAccount: 'o envía usando nuestra cuenta predeterminada.',
		selectCustomEmailError:
			'Selecciona una cuenta de correo personalizada para programar la tarjeta o elige la opción de enviar usando nuestro correo predeterminado.',
		planNoCustomEmail: 'Tu plan no permite añadir cuentas de correo personalizadas. Mejora tu plan',
		emailAccountsLimitReached:
			'Has alcanzado el límite de cuentas de correo. Mejora tu plan para añadir más cuentas de correo',

		// Add recipient intro / empty state
		addRecipientsIntro:
			'Puedes añadir destinatarios de forma individual o importar una lista de contactos subiendo un CSV masivo',
		noRecipientsYet: 'Aún no tienes destinatarios.',
		addNamesEmails: 'Añade los nombres y las direcciones de correo de los destinatarios de tu tarjeta.',
		uploadCsv: 'Subir CSV',
		addRecipient: 'Añadir destinatario',

		// Contact list
		prepareContactList: 'Preparemos tu lista de contactos',
		fileUploadedPrepare:
			'Tu archivo se ha subido correctamente. Ahora preparémoslo para la personalización de las tarjetas',
		contactListTitle: 'Título de la lista de contactos',
		whatIsContactList: '¿Qué es una lista de contactos?',
		contactListDescription:
			'Una lista de contactos es una libreta de direcciones que puedes usar cuando quieras para enviar tarjetas personalizadas y masivas',
		noCsvSelected: 'ningún archivo csv seleccionado',

		// Merge tags
		selectMergeTags: 'SELECCIONAR ETIQUETAS DE COMBINACIÓN',
		whatIsMergeTag: '¿Qué es una etiqueta de combinación?',
		mergeTagDescription:
			'Las etiquetas de combinación son etiquetas personalizadas asociadas a tus datos masivos para personalizar documentos, gráficos, etc.',
		enterTagName: 'Introduce el nombre de la etiqueta',
		addNewMergeTagBtn: 'Añadir nueva etiqueta de combinación',
		duplicateMergeTag: 'No se puede añadir una etiqueta de combinación con el mismo nombre.',

		// Upload CSV modal
		uploadCsvHere: 'Sube aquí tu archivo CSV',
		uploadCsvDescription:
			'Una vez que subas tu CSV, %{app} asociará tus datos con las etiquetas de combinación disponibles junto con etiquetas personalizadas para que personalices cada tarjeta y envíes tarjetas a tantos contactos como quieras',
		downloadCsvTemplate: 'Descargar plantilla CSV',
		csvColumnsLabel: 'Columnas:',
		csvExtraColumns: '. Las columnas adicionales se convierten en etiquetas de combinación.',
		csvExampleLabel: 'Ejemplo:',
		changeFile: 'Cambiar archivo',
		csvFileLabel: 'Archivo CSV',
		clickToUpload: 'Haz clic para subir tu archivo csv',

		// Recipients table / list
		recipientsHeader: 'DESTINATARIOS',
		missingFields: 'Campos faltantes',
		errorsCount: '%{count} error(es)',
		invalidRecipientEmails: 'Correos de destinatarios no válidos',
		invalidEmailsCount: '%{count} correo(s) no válido(s)',
		fromLabel: 'De',
		listSuffix: 'lista',
		addNewRecipient: 'Añadir nuevo destinatario',
		copyCardUrl: 'Copiar URL de la tarjeta',
		scheduleForLater: 'Programar para más tarde',
		saveAndNext: 'Guardar y siguiente',
		selectAll: 'Seleccionar todo',
		unnamed: 'Sin nombre',
		noRecipientsFound: 'No se encontraron destinatarios.',

		// Toasts / swal (recipients)
		updatedRecipientSuccess: 'Destinatario actualizado correctamente',
		addedRecipientSuccess: 'Destinatario añadido correctamente',
		decrementLimitByCount: '¡Esta acción reducirá tu límite de destinatarios en %{count}!',
		decrementLimit: '¡Esta acción reducirá tu límite de destinatarios!',
		linkCopied: 'Enlace copiado correctamente',

		// Copy card URL modal
		getCardUrls: 'Obtener URLs de la tarjeta',
		copyUrlDescription:
			'Puedes copiar la URL de los destinatarios y enviárselas directamente por cualquier medio, p. ej. messenger, whatsapp, etc.',
		downloadAsCsv: 'Descargar como CSV',
		copyUrl: 'Copiar URL',
		noRecipientsToCopy: 'No hay destinatarios para copiar.',

		// Schedule modals
		scheduleCard: 'Programar tarjeta',
		addDateTimeDescription:
			'Añadamos la fecha y la hora en que quieres que tus contactos reciban la tarjeta. También puedes cambiar la programación manualmente para cada destinatario.',
		selectDateTime: 'Selecciona fecha y hora',
		missingData: 'Datos faltantes',
		missingDataDescription:
			'Tienes algunos datos faltantes en las columnas que podrían causar un problema al enviar las tarjetas.',
		updateData: 'Actualizar datos',
		skipContinue: 'Omitir y continuar',

		// Add recipient modal / form
		recipientInfo: 'Información del destinatario',
		updateRecipientInfoDesc: 'Actualiza la información de tus destinatarios para que reciban la tarjeta correctamente.',
		addNameEmailDesc: 'Añade el nombre y la dirección de correo del destinatario',
		basicInfo: 'INFORMACIÓN BÁSICA',
		nameLabel: 'nombre',
		emailLabel: 'correo',
		nameOfRecipient: 'Nombre del destinatario',
		mergeTagsLabel: 'ETIQUETAS DE COMBINACIÓN',
		recurring: 'Recurrente',
		yearly: 'Anual',
		monthly: 'Mensual',
		weekly: 'Semanal',
		daily: 'Diario',

		// Customize subject / preview
		whoIsCardFrom: 'De quién es esta tarjeta',
		recipientsLeft: 'Te quedan %{count} destinatario(s)',
		unlimitedRecipients: 'Tienes destinatarios de correo ilimitados',
		customizeSubjectEmail: 'Personaliza el asunto del correo.',
		customizeHeader: 'Personaliza el encabezado de la vista previa de la tarjeta',
		customizeFooter: 'Personaliza el pie de la vista previa de la tarjeta',
		addCta: 'Añadir CTA en la tarjeta de vista previa',
		toggleConfetti: 'Activar/desactivar confeti',
		howCardLooksEmail: '¿Cómo se ve la tarjeta en el correo?',
		howCardLooksViewScreen: '¿Cómo se ve la tarjeta en la pantalla de vista de la tarjeta?',
		enterSenderName: 'Introduce el nombre del remitente',
		subjectLinePlaceholder: 'Hola %{tag}, %{name} creó una tarjeta digital para ti.',
		subjectLineFromPlaceholder: 'Hola %{tag}, de %{name} creó una tarjeta digital para ti.',
		cardPreviewHeaderPlaceholder: 'Encabezado de la vista previa de la tarjeta',
		cardPreviewFooterPlaceholder: 'Pie de la vista previa de la tarjeta',
		unsubscribeTextPlaceholder: 'Texto del enlace para cancelar la suscripción (opcional)',
		ctaTextLabel: 'Texto',
		ctaPlaceholder: 'Haz clic aquí',
		subjectLineHint:
			'Añade un nombre de remitente preferido y una línea de asunto. También puedes añadir etiquetas de combinación en la línea de asunto',

		// Scheduled recipients table / fallback date
		cardsReadyToSchedule: 'Tarjeta(s) lista(s) para programar',
		manualScheduleHint: 'Puedes cambiar manualmente la programación de cada tarjeta si lo deseas',
		sendDateFallbackLabel: 'Fecha de envío para destinatarios sin fecha en el CSV',
		fallbackHintCsv:
			'Los destinatarios con un schedule_date válido en tu CSV conservan su propia fecha. Esta fecha de reserva se aplica a todos los demás.',
		fallbackHintNoCsv: 'Aplica esta fecha a todos los destinatarios. Anula filas individuales en la tabla de abajo.',
		pickFallbackDate: 'Elige una fecha de reserva',
		applyScheduleDates: 'Aplicar fechas de programación',
		sendCard: 'Enviar tarjeta',
		scheduledAt: 'Programado para',
		now: 'Ahora',
		noSelectedRecipients: 'No se encontraron destinatarios seleccionados.',

		// Email preview
		emailFooterDefault: 'Tu bandeja de entrada acaba de recibir una entrega especial. Ve tu tarjeta en línea.',
		viewCard: 'Ver tarjeta',
		unsubscribe: 'darse de baja',

		// Toasts / swal (schedule / apply)
		cardScheduledSuccess: '¡Tarjeta programada!',
		saveCardProblem: 'Hubo un problema al guardar tu tarjeta. Inténtalo de nuevo.',
		pickFallbackOrCsv: 'Elige una fecha de envío de reserva o sube un CSV con una columna schedule_date.',
		scheduleAppliedCount: 'Programación aplicada a %{count} destinatario(s).',
		applyScheduleFailed: 'No se pudieron aplicar las fechas de programación. Inténtalo de nuevo.',
	} as Record<string, string>,
};
export default schedule;
